import { inject, Injectable } from '@angular/core';
import { LanguageService } from 'language';
import { CmsService, FooterDocumentDataBodyLinksAreaSlice } from 'prismic';
import { CachedDataLoaderService } from 'utils';
import { Footer } from '../classes/footer.class';
import { PrismicService } from './prismic.service';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  cms = inject(CmsService);
  cachedDataLoader = inject(CachedDataLoaderService);
  lang = inject(LanguageService);
  prismic = inject(PrismicService);

  async getFooter(): Promise<Footer> {
    return (await this.getAll()).footer;
  }

  private async getAll() {
    return await this.cachedDataLoader.get('footer_' + this.lang.current, () => this.loadFooterItems());
  }

  private async loadFooterItems() {
    const resp = await this.cms.getByType('footer');
    const result = resp?.[0]?.data as { body: FooterDocumentDataBodyLinksAreaSlice[] };

    return {
      footer: await this.prismic.convertFooter(result.body),
    };
  }
}
